var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropWaterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 28.5001C42 38.4301 33.93 46.5001 24 46.5001C14.07 46.5001 6 38.4301 6 28.5001C6 18.8701 22.245 2.62509 22.95 1.93509C23.535 1.35009 24.465 1.35009 25.05 1.93509C25.755 2.62509 42 18.8701 42 28.5001Z",
    fill: "#3E7CA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 39C16.0371 39 12 34.9629 12 30C12 29.171 12.6717 28.5 13.5 28.5C14.3283 28.5 15 29.171 15 30C15 33.3091 17.6916 36 21 36C21.8283 36 22.5 36.6709 22.5 37.5C22.5 38.3291 21.8283 39 21 39Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropWaterIcon);
export default __webpack_public_path__ + "static/media/drop-water-icon.0e2f8a5057e957f6458c228005d9ca14.svg";
export { ForwardRef as ReactComponent };